import { render, staticRenderFns } from "./CNavLinksMenu.vue?vue&type=template&id=74c799ba&"
import script from "./CNavLinksMenu.vue?vue&type=script&lang=js&"
export * from "./CNavLinksMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports